import * as utils from '../../../../shared/utils';

const SEARCH_FILTERS_MINIMIZED_KEY = 'picsio.searchFiltersMinimized';

export function getInitialSearchFiltersCollapsed(isMediaLibraryModal) {
  if (isMediaLibraryModal) return true;
  return Boolean(utils.LocalStorage.get(SEARCH_FILTERS_MINIMIZED_KEY));
}

export function persistSearchFiltersMinimized(isMediaLibraryModal, isMinimized) {
  if (isMediaLibraryModal) return;
  utils.LocalStorage.set(SEARCH_FILTERS_MINIMIZED_KEY, isMinimized);
}
